import * as yup from 'yup';

const credentialsSchema = yup.object().shape({
  netSuite: yup.object().shape({
    consumerKey: yup
      .string()
      .trim()
      .required('Consumer Key is required!'),
    consumerSecret: yup
      .string()
      .trim()
      .required('Consumer Secret is required!'),
    tokenKey: yup
      .string()
      .trim()
      .required('Token Key is required!'),
    tokenSecret: yup
      .string()
      .trim()
      .required('Token Secret is required!'),
    accountId: yup
      .string()
      .trim()
      .required('Account ID is required!'),
  }),
});

export default credentialsSchema;

